import { RFQ } from '@fortem-monorepo/web-sdk'

export const useEnums = (data: RFQ.GetPricingMatrixData) => {
  const banks = [
    ...new Set(
      data.flatMap((item) =>
        Object.keys(item.banks)
          .map((b) => b.trim())
          .filter(Boolean),
      ),
    ),
  ].sort()

  const products = [
    ...new Set(
      data
        .flatMap((item) => (item.type ?? '').split(', '))
        .map((b) => b.trim())
        .filter(Boolean),
    ),
  ].sort()

  const underlyings = [
    ...new Set(
      data
        .flatMap((item) => item.underlyings)
        .map((str) =>
          (str ?? '')
            .split(',')
            .map((str) => str.trim())
            .sort()
            .join(', '),
        )
        .filter((val) => val !== null),
    ),
  ].sort()

  const types = [
    ...new Set(data.map((item) => item['Live/Indicative']).filter((val) => val !== null)),
  ].sort()

  return {
    banks,
    products,
    underlyings,
    types,
  }
}
